module.exports = __webpack_public_path__ + "assets/img/Brighten-Home-Loans-Website-w540.690f1067.webp";